module.exports = __webpack_public_path__ + "static/claims-hero.480eb743.webp";